'use strict';

import { hostFactory as hostInstance } from "@api/factory";

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[api::companies::users]';

const getUsers = (companyId) => {
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/companies/${companyId}/users`);
}

export default {
  getUsers,
};
